import { render, staticRenderFns } from "./BaseShopDetails.vue?vue&type=template&id=7a18f561&scoped=true"
import script from "./BaseShopDetails.vue?vue&type=script&lang=js"
export * from "./BaseShopDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseShopDetails.vue?vue&type=style&index=0&id=7a18f561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a18f561",
  null
  
)

export default component.exports